<template>
    <div>
        <em
            v-if="!value"
            class="text-info"
        >
            None
        </em>
        <BadgeTotal
            v-else
            :value="value"
            :color="color"
        ></BadgeTotal>
    </div>
</template>

<script>
import BadgeTotal from './BadgeTotal';

export default {
    components: { BadgeTotal },
    props: {
        value: {
            type: [Number, String],
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
    },
};
</script>
